module.exports = __webpack_public_path__ + "static/flip3-192404ebc25418fb40bcee60455e20ba.png";